import { render, staticRenderFns } from "./GeneralSpecialtyInfo.vue?vue&type=template&id=58a9231b&scoped=true&"
import script from "./GeneralSpecialtyInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a9231b",
  null
  
)

export default component.exports